import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getLoadSizeValue } from '@ordersnproducts/utils/common-utils';
import { distinctUntilChanged, filter, map, takeUntil, tap } from 'rxjs/operators';
import { SpecFieldNames } from '../../specification/constants/specification-field-names.enum';
import { getRmsRecipeSpecifications } from '../selectors';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { of, Observable } from 'rxjs';
import { Features } from '@ordersnproducts/features';
import { getDcoStatusState } from '../../../../shared/reducers';
import { NA_SPACING_CODE } from '../../specification/configs/us/constants';

export namespace SpacingDisabledProvider {
  export class Disabled extends BaseAsyncValue<boolean> {
    protected modifyHaveChanges = false;
    getValue(): Observable<boolean> {
      return this.getDisabledValue();
    }

    protected getDisabledValue(isModify = false): Observable<boolean> {
      const featureToggle: FeatureToggleService = this.injector.get(FeatureToggleService);
      const toggle = featureToggle.isFeatureEnabled(Features.EnableSpacingValidationByQtyLoadSize);

      return toggle
        ? this.store.select(getRmsRecipeSpecifications).pipe(
            filter(
              (recipe) =>
                recipe.length > 0 &&
                !!recipe[0].values[SpecFieldNames.QUANTITY] &&
                !!recipe[0].values[SpecFieldNames.LOAD_SIZE],
            ),
            takeUntil(this.ngDestroy),
            distinctUntilChanged(
              (prev, curr) =>
                prev[0].values[SpecFieldNames.QUANTITY] === curr[0].values[SpecFieldNames.QUANTITY] &&
                prev[0].values[SpecFieldNames.LOAD_SIZE] === curr[0].values[SpecFieldNames.LOAD_SIZE],
            ),
            map((recipe) => {
              const quantity = recipe[0].values[SpecFieldNames.QUANTITY];
              const loadSize = recipe[0].values[SpecFieldNames.LOAD_SIZE];
              const spacing = recipe[0].values[SpecFieldNames.SPACING];
              const loadSizeValue = getLoadSizeValue(loadSize);
              const moreThanOneSpacing = quantity > loadSizeValue;
              if (
                isModify &&
                !this.modifyHaveChanges &&
                !!spacing &&
                spacing.spacingCode === NA_SPACING_CODE &&
                !moreThanOneSpacing
              ) {
                return true;
              }
              return !moreThanOneSpacing;
            }),
          )
        : of(false);
    }
  }

  export class DisabledModify extends Disabled {
    getValue(): Observable<boolean> {
      this.store.select(getDcoStatusState).pipe(
        filter((state) => !!state),
        takeUntil(this.ngDestroy),
        tap((state) => {
          this.modifyHaveChanges = state.haveChanges;
        }),
      );
      return this.getDisabledValue(true);
    }
  }
}
